import { sysColors } from "@/assets/theme/colors";

/**
 * Custom empty state for Photobooth search with camera flash illustration
 */
export default function PhotoboothEmptyState() {
  return (
    <div className="flex flex-col items-center justify-center py-8">
      {/* Camera Flash Illustration */}
      <div className="w-64 h-64 relative mb-6">
        <svg className="w-full h-full overflow-visible" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
          {/* Left background camera (rotated) */}
          <g className="text-gray-300" transform="translate(-40, 20) rotate(-15, 100, 100)">
            <rect fill="currentColor" height="50" rx="4" width="16" x="92" y="120" />
            <circle
              cx="100"
              cy="90"
              fill={sysColors["sys-brand-surface-dim"]}
              r="30"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="100" cy="90" fill="none" opacity="0.5" r="24" stroke="currentColor" strokeWidth="1" />
            <circle cx="100" cy="90" fill="white" r="8" stroke="currentColor" strokeWidth="1" />
          </g>

          {/* Right background camera (rotated) */}
          <g className="text-gray-300" transform="translate(40, 20) rotate(15, 100, 100)">
            <rect fill="currentColor" height="50" rx="4" width="16" x="92" y="120" />
            <circle
              cx="100"
              cy="90"
              fill={sysColors["sys-brand-surface-dim"]}
              r="30"
              stroke="currentColor"
              strokeWidth="2"
            />
            <circle cx="100" cy="90" fill="none" opacity="0.5" r="24" stroke="currentColor" strokeWidth="1" />
            <circle cx="100" cy="90" fill="white" r="8" stroke="currentColor" strokeWidth="1" />
          </g>

          {/* Main center camera */}
          <g transform="translate(0, 0)">
            {/* Handle */}
            <rect className="fill-gray-600" height="60" rx="4" width="20" x="90" y="130" />
            {/* Connector */}
            <rect fill="#9CA3AF" height="15" width="12" x="94" y="115" />
            {/* Main lens body */}
            <circle className="fill-gray-100 stroke-gray-600" cx="100" cy="85" r="40" strokeWidth="2" />
            {/* Inner rings */}
            <circle className="stroke-gray-300" cx="100" cy="85" fill="none" r="32" strokeWidth="1" />
            <circle className="stroke-gray-300" cx="100" cy="85" fill="none" r="24" strokeWidth="1" />
            {/* Gold center (flash bulb) */}
            <circle className="fill-amber-500" cx="100" cy="85" r="10" />
            {/* Highlight */}
            <circle cx="100" cy="85" fill="#FFF" opacity="0.8" r="6" />
          </g>

          {/* Flash rays */}
          <g className="stroke-amber-500" strokeLinecap="round" strokeWidth="2.5">
            {/* Top ray */}
            <line x1="100" x2="100" y1="60" y2="40" />
            {/* Bottom ray (faded) */}
            <line opacity="0.5" x1="100" x2="100" y1="110" y2="120" />
            {/* Left ray */}
            <line x1="75" x2="55" y1="85" y2="85" />
            {/* Right ray */}
            <line x1="125" x2="145" y1="85" y2="85" />
            {/* Top-left diagonal */}
            <line x1="82" x2="68" y1="67" y2="53" />
            {/* Top-right diagonal */}
            <line x1="118" x2="132" y1="67" y2="53" />
            {/* Bottom-left diagonal (faded) */}
            <line opacity="0.5" x1="82" x2="72" y1="103" y2="113" />
            {/* Bottom-right diagonal (faded) */}
            <line opacity="0.5" x1="118" x2="128" y1="103" y2="113" />

            {/* Sparkle diamonds */}
            <path d="M150 40 L153 43 L150 46 L147 43 Z" fill="#F59E0B" stroke="none" />
            <path d="M50 50 L54 54 L50 58 L46 54 Z" fill="#F59E0B" stroke="none" />
            <path d="M160 100 L162 104 L160 108 L158 104 Z" fill="#F59E0B" opacity="0.6" stroke="none" />
          </g>
        </svg>
      </div>

      {/* Title */}
      <h2 className="text-title-large font-bold text-sys-brand-on-surface mb-2">Blinded by the Light?</h2>

      {/* Description */}
      <p className="text-body-medium text-sys-brand-on-surface-variant text-center max-w-[280px]">
        We couldn&apos;t find any people based on your search. Adjust the lighting and try again.
      </p>
    </div>
  );
}
